import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttachmentDownloadGQL, GetRequestActvityAttachmentGQL } from './../../../../../generated/cloudapigql';
import { SharedService } from '../../../../../services/shared.service';
import { Utils } from '../../../../shared/utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HeaderTemplateData } from '../../dialog/dialog-data.interface';
import { map } from 'rxjs/operators';

// export interface DialogData {
//     title: [];
//     type: number;
//     amount: number;
//     att: any [];
// }
export interface attachment extends HeaderTemplateData {
  attachment: any;
}

@UntilDestroy()
@Component({
  selector: 'attachment-dialog',
  templateUrl: 'attachment-dialog.html',
  styleUrls: ['attachment-dialog.scss']
})

export class AttachmentDialog implements OnInit {
  result: any = [];
  header: HeaderTemplateData;
  attachmentBase64: any;

  constructor(
    public dialogRef: MatDialogRef<AttachmentDialog>,
    public shareService: SharedService,
    public getRequestActvityAttachmentGQL: GetRequestActvityAttachmentGQL,
    private attachmentDownloadGQL: AttachmentDownloadGQL,
    @Inject(MAT_DIALOG_DATA) private _data: any
  ) {
    if (this._data != null) {
      this.header = _data;
      this.getRequestActvityAttachmentGQL.fetch({
        input: {
          refId: this._data.attachment.attachment.refId,
          refTable: this._data.attachment.attachment.refTable,
          module: 'servicerequest',
        }
      }).pipe(untilDestroyed(this))
        .subscribe(x => {
          this.result = x.data.AttachmentByRefIdAndRefTable;
        })
    }
  }

  download(attachment) {
    // Utils.downloadFileByUrl(attachment.resourceUrl, attachment.fileName);
    this.attachmentDownloadGQL.fetch({ url: attachment.resourceUrl }).pipe(
      map(x => x.data.AttachmentDownload)
    ).subscribe(res => {
      this.attachmentBase64 = res;
      let file = {
        base64File: this.attachmentBase64.base64File,
        mediaType: attachment.mediaType,
        fileName: attachment.fileName
      }
      Utils.downloadFile(file);
    })
    this.shareService.insertDownloadLog(attachment.fileName, attachment.fileSize, location.href, attachment.ID).subscribe();
  }

  ngOnInit() {
  }

}
